import {
  Box,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Container,
  Tooltip,
} from "@mui/material";
import React from "react";
import ApiEndpoints from "../network/ApiEndPoints";
import CachedIcon from "@mui/icons-material/Cached";
import { useState } from "react";
import { CustomStyles } from "../component/CustomStyle";
import BlockUnBlockPlans from "../modals/BlockUnBlockPlans";
import AddPlanModal from "../modals/AddPlanModal";
import DeletePlan from "../modals/DeletePlan";
import EditPlanModal from "../modals/EditPlanmodal";
import { currencySetter } from "../utils/Currencyutil";
import ApiPaginate from "../component/ApiPaginate";
import { dateToTime, ddmmyy } from "../utils/DateUtils";
import AddAppVersion from "../modals/AddAppVersion";

let refresh;
function refreshFunc(setQueryParams) {
  setQueryParams("");
  if (refresh) refresh();
}

const AppVersion = () => {
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState();

  const handleChangeOperator = (event) => {
    if (event.target.value !== "Operators") {
      setQuery(`operator=${event.target.value}`);
    }
  };
  const columns = [
      {
          name: "Date/Time",
          selector: (row) => (
            <div className="mb-1" style={{ textAlign: "left" }}>
              {ddmmyy(row.created_at)} {dateToTime(row.created_at)}
            </div>
          ),
          wrap: true,
        },
  
    {
      name: "id",
      selector: (row) => row.id,
    },
    {
      name: "platform",
      selector: (row) => row.platform,
    },
    {
      name: "version",
      selector: (row) => row.version,
    },
    {
      name: "message",
      selector: (row) => row.message,
    },



   
  ];

  const searchOptions = [
    { field: "Plan", parameter: "plan" },
    { field: "Validity", parameter: "validity" },
  ];

  return (
    <>
      <Box>
        {/* <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Tooltip title="export">
          <IconButton aria-label="export" color="secondary">
            <ExitToAppIcon />
          </IconButton>
        </Tooltip>
        <AddPlanModal refresh={refresh} />
        <Tooltip title="refresh">
          <IconButton
            aria-label="refresh"
            color="success"
            onClick={() => {
              refreshFunc(setQuery);
            }}
          >
            <CachedIcon className="refresh-purple" />
          </IconButton>
        </Tooltip>
      </Box> */}
        <div>
          <Grid
            item
            md={4}
            sm={6}
            xs={6}
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <AddAppVersion refresh={refresh} />

            <Tooltip title="refresh">
              <IconButton
                aria-label="refresh"
                // color="success"
                sx={{
                  color: "#0F52BA",
                }}
                onClick={() => {
                  refreshFunc(setQuery);
                }}
              >
                <CachedIcon className="refresh-purple" />
              </IconButton>
            </Tooltip>
          </Grid>

          <ApiPaginate
            apiEnd={ApiEndpoints.GET_APP_VERSION}
            columns={columns}
            apiData={apiData}
            tableStyle={CustomStyles}
            setApiData={setApiData}
            queryParam={query ? query : ""}
            setQuery={setQuery}
            ExpandedComponent={null}
            returnRefetch={(ref) => {
              refresh = ref;
            }}
          />

          {/* <ApiPaginate
          apiEnd={ApiEndpoints.GET_PLANS}
          columns={columns}
          apiData={apiData}
          tableStyle={CustomStyles}
          setApiData={setApiData}
          ExpandedComponent=""
          queryParam={query ? query : ""}
          returnRefetch={(ref) => {
            refresh = ref;
          }}
        /> */}
        </div>
      </Box>
    </>
  );
};

export default AppVersion;
